import React from 'react';
import { useSelector } from 'react-redux';

import StressImage from '../../assets/images/death_reasons/stressImage';
import StressEng from '../../assets/images/death_reasons/stressEng';
import StressRus from '../../assets/images/death_reasons/stressRus';
import Border from '../../assets/images/border';

import './stress.scss';

const Cancer = () => {
    const { language } = useSelector(state => state.user);

    return (
        <div className='stress'>
            <Border />
            {language === 'ENG' ? <StressEng /> : <StressRus />}
            <StressImage />
            <span className='stress-text'>
                {language === 'RUS' ? 'Хронический стресс является одним из факторов риска для развития сердечно-сосудистых заболеваний, инсульта и рака. Стресс может увеличить вероятность смерти от этих заболеваний на 30-40%. Даже при здоровом образе жизни.' : 'Chronic stress is a risk factor for heart disease, stroke, and cancer. Stress can increase the likelihood of death from these conditions by 30-40%. Even with a healthy lifestyle, managing stress levels is essential to reduce risks.'}
            </span>
        </div>
    );
};

export default Cancer;